import styled from 'styled-components';
import { body, breakpoint, canvas, heading, spacing, text } from '@carvana/ds-styles';

const Container = styled.div`
  width: 100%;
  background-color: ${canvas.default};
`;

const Content = styled.div`
  margin: 0 auto;
  padding: 50px 0;
  width: 327px;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: 704px;
    padding: 60px 0;
  }
`;

const BodyText = styled.p`
  ${body.regular.md}
  color: ${text.default};
  margin-top: ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.md}) {
    width: 630px;
    margin-left: 30px;
  }
`;

const Title = styled.p`
  ${heading['2Xl']}
  color: ${text.default};

  @media screen and (min-width: ${breakpoint.sm}) {
    text-align: center;
  }
`;

export { Container, Content, Title, BodyText };
